import type {
  AgentConnectionInstructionsResponse,
  AgentConnectionStatus,
  AgentConnectionSummaryResponse,
} from '@contract-analyzer/api-client';
import { createContext, useContext } from 'react';

/**
 * Present only for users the API reports as eligible. Everyone else gets
 * `null`, so no surface can mention the feature.
 */
export interface AgentConnectionController {
  readonly instructions: AgentConnectionInstructionsResponse;
  readonly connection: AgentConnectionSummaryResponse;
  /**
   * What the sidebar entry shows. It holds the invitation while the dialog is
   * confirming a fresh connection, so the entry shrinks where the user can see it.
   */
  readonly entryStatus: AgentConnectionStatus;
  /** The entry arrives in its connected form for the first time; play its confirmation. */
  readonly celebrate: boolean;
  readonly openPrompt: () => void;
}

export const AgentConnectionCtx = createContext<AgentConnectionController | null>(null);

export function useAgentConnection(): AgentConnectionController | null {
  return useContext(AgentConnectionCtx);
}
